import { render, staticRenderFns } from "./InitialChallengeScreen.vue?vue&type=template&id=380abedf&scoped=true&"
import script from "./InitialChallengeScreen.vue?vue&type=script&lang=js&"
export * from "./InitialChallengeScreen.vue?vue&type=script&lang=js&"
import style0 from "./InitialChallengeScreen.vue?vue&type=style&index=0&id=380abedf&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "380abedf",
  null
  
)

export default component.exports